import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import {
  ContractMachinesResponse,
  ContractMachineDetailType,
  CreateContractMachineRequest,
  UpdateContractMachineRequest,
  CopyMachinesRequest,
} from "../types/ContractMachine";

const baseUrl = "/api/ContractMachines";

async function authHeader(): Promise<Record<string, string>> {
  const token = await getApiAccessToken();
  return { Authorization: `Bearer ${token}` };
}

export const getContractMachines = async (
  addressSystemId: number,
  contractId?: number | null,
): Promise<ContractMachinesResponse> => {
  const headers = await authHeader();
  const response = await apiClient.get<ContractMachinesResponse>(
    `${baseUrl}/${addressSystemId}`,
    {
      headers,
      params: contractId ? { contractId } : undefined,
    },
  );
  return response.data;
};

export const getContractMachineDetail = async (
  addressSystemId: number,
  machineId: number,
): Promise<ContractMachineDetailType> => {
  const headers = await authHeader();
  const response = await apiClient.get<ContractMachineDetailType>(
    `${baseUrl}/${addressSystemId}/${machineId}`,
    { headers },
  );
  return response.data;
};

export const createContractMachine = async (
  addressSystemId: number,
  contractId: number,
  request: CreateContractMachineRequest,
): Promise<number> => {
  const headers = await authHeader();
  const response = await apiClient.post<{ id: number }>(
    `${baseUrl}/${addressSystemId}/contracts/${contractId}/machines`,
    request,
    { headers },
  );
  return response.data.id;
};

export const updateContractMachine = async (
  addressSystemId: number,
  contractId: number,
  machineId: number,
  request: UpdateContractMachineRequest,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.put(
    `${baseUrl}/${addressSystemId}/contracts/${contractId}/machines/${machineId}`,
    request,
    { headers },
  );
};

export const deleteContractMachine = async (
  addressSystemId: number,
  contractId: number,
  machineId: number,
): Promise<void> => {
  const headers = await authHeader();
  await apiClient.delete(
    `${baseUrl}/${addressSystemId}/contracts/${contractId}/machines/${machineId}`,
    { headers },
  );
};

export const copyMachinesFromTemplate = async (
  addressSystemId: number,
  request: CopyMachinesRequest,
): Promise<number> => {
  const headers = await authHeader();
  const response = await apiClient.post<{ copiedCount: number }>(
    `${baseUrl}/${addressSystemId}/copy`,
    request,
    { headers },
  );
  return response.data.copiedCount;
};
